import NotFoundError from './NotFoundError';
import RequestError from './RequestError';
import TimeoutError from './TimeoutError';

const isNetworkRequestError = (error: unknown): boolean =>
  error instanceof RequestError && error.meta?.status === undefined;

export const isExpectedSignalingError = (error: unknown): boolean =>
  error instanceof NotFoundError
  || error instanceof TimeoutError
  || isNetworkRequestError(error);
